define('views/components/cd_role/cd_role',['require','backbone','text!templates/components/cd_role/cd_role.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/cd_role/cd_role.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'cd-role-item'
    });
});
